import { Helmet } from "react-helmet-async";

const SITE_NAME = "TJP Carpentry & Construction";
const DEFAULT_DESCRIPTION = "Professional carpentry and construction services in Surrey and SW London. Loft conversions, house extensions, kitchen fitting, and more. Over 10 years experience. Free estimates.";
const SITE_URL = "https://tjpconstruction.co.uk";
const DEFAULT_IMAGE = "/images/projects/Extension2.JPG";
const PHONE = "07780 996775";

const SEO = ({ 
  title, 
  description = DEFAULT_DESCRIPTION, 
  keywords = "",
  image = DEFAULT_IMAGE,
  url = "",
  type = "website",
  noIndex = false 
}) => {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} | Quality Carpentry Surrey & SW London`;
  const fullUrl = url ? `${SITE_URL}${url}` : SITE_URL;
  const fullImage = image.startsWith("http") ? image : `${SITE_URL}${image}`;
  
  const defaultKeywords = "carpentry surrey, carpenter sw london, loft conversion surrey, house extension guildford, kitchen fitter surrey, bathroom renovation london, fitted wardrobes, home refurbishment, builder surrey, construction services";
  const allKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={allKeywords} />
      <meta name="author" content={SITE_NAME} />
      <link rel="canonical" href={fullUrl} />
      
      {/* Robots */}
      {noIndex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow" />
      )}
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="en_GB" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImage} />
      
      {/* Geo Tags */}
      <meta name="geo.region" content="GB-SRY" />
      <meta name="geo.placename" content="Surrey" />
      
      {/* Contact */}
      <meta name="contact" content={PHONE} />
    </Helmet>
  );
};

export default SEO;
